<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="edit-schedule-modal" (click)="onModalClick($event)">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Edit Schedule</h2>
      <button class="close-button" (click)="onClose()" [disabled]="isSubmitting">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3L3 9M3 3L9 9" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Header Divider -->
    <div class="header-divider"></div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Loading State -->
      <div *ngIf="isLoadingSchedule" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Loading schedule data...</p>
      </div>

      <!-- Employee Info Section -->
      <div class="employee-info-section" *ngIf="employeeInfo && !isLoadingSchedule">
        <div class="employee-avatar">
          <img *ngIf="employeeInfo.picture_url" [src]="employeeInfo.picture_url" [alt]="employeeInfo.name" class="avatar-image">
          <div *ngIf="!employeeInfo.picture_url" class="avatar-placeholder">
            {{ getEmployeeInitials() }}
          </div>
        </div>
        <div class="employee-details">
          <div class="employee-name">{{ employeeInfo.name }}</div>
          <div class="employee-meta">
            <span class="employee-id">{{ employeeInfo.empId }}</span>
            <span class="meta-separator">|</span>
            <span class="employee-designation">{{ employeeInfo.designation }}</span>
          </div>
        </div>
      </div>

      <!-- Section Divider -->
      <div class="section-divider"></div>

      <!-- Week Section -->
      <div class="week-section" *ngIf="!isLoadingSchedule">
        <label class="section-label">Week:</label>
        <span class="week-value">{{ weekRange }}</span>
      </div>

      <!-- Shift Section -->
      <div class="shift-section" *ngIf="!isLoadingSchedule">
        <label class="section-label">Shift:</label>
        <div class="custom-dropdown shift-dropdown" [class.disabled]="isSubmitting || isLoadingShifts">
          <div class="dropdown-selected" (click)="toggleShiftDropdown()" [class.disabled]="isSubmitting || isLoadingShifts">
            <span class="selected-value" [class.placeholder]="!selectedShiftId">
              {{ getSelectedShiftName() }}
            </span>
            <svg class="dropdown-arrow" [class.rotated]="openShiftDropdown" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
            </svg>
          </div>
          <div class="dropdown-menu" [class.show]="openShiftDropdown">
            <div class="dropdown-option" 
                 *ngFor="let shift of shifts; trackBy: trackById"
                 [class.selected]="selectedShiftId === shift.id"
                 (click)="selectShift(shift.id)">
              {{ shift.shift_name }}
            </div>
          </div>
        </div>
      </div>

      <!-- Daily Schedule Section (Reused from Add Shift Modal) -->
      <div class="daily-schedule-section" *ngIf="!isLoadingSchedule">
        <!-- Schedule Headers -->
        <div class="schedule-headers">
          <div class="header-cell days-header">Days</div>
          <div class="header-cell status-header">Status</div>
          <div class="header-cell time-headers-wrapper">
            <span class="header-time-cell">Time from</span>
            <span class="header-separator"></span>
            <span class="header-time-cell">Time to</span>
          </div>
        </div>

        <!-- Divider after headers -->
        <div class="headers-divider"></div>

        <!-- Schedule Rows -->
        <div class="schedule-rows" *ngIf="!isLoadingSchedule && days.length > 0">
          <div *ngFor="let day of days; let i = index; trackBy: trackByIndex">
            <div class="schedule-row">
              <div class="day-cell">{{ day.day }}</div>
              <div class="status-cell">
                <label class="mobile-label">Status</label>
                <div class="custom-dropdown" [class.disabled]="isSubmitting">
                  <div class="dropdown-selected" (click)="toggleStatusDropdown(i)" [class.disabled]="isSubmitting">
                    <span class="selected-value">{{ day.status }}</span>
                    <svg class="dropdown-arrow" [class.rotated]="openStatusDropdowns[i]" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
                    </svg>
                  </div>
                  <div class="dropdown-menu" [class.show]="openStatusDropdowns[i]">
                    <div class="dropdown-option" 
                         [class.selected]="day.status === 'Working'"
                         (click)="onDayStatusChange(i, 'Working')">
                      Working
                    </div>
                    <div class="dropdown-option" 
                         [class.selected]="day.status === 'Leave'"
                         (click)="onDayStatusChange(i, 'Leave')">
                      Leave
                    </div>
                    <div class="dropdown-option" 
                         [class.selected]="day.status === 'Half day leave'"
                         (click)="onDayStatusChange(i, 'Half day leave')">
                      Half day leave
                    </div>
                  </div>
                </div>
              </div>
              <div class="time-fields-container">
                <div class="start-time-cell">
                  <label class="mobile-label">Time from</label>
                  <div class="custom-dropdown time-dropdown-disabled" [class.disabled]="true">
                    <div class="dropdown-selected" [class.disabled]="true">
                      <span class="selected-value">{{ (day.status === 'Working' || day.status === 'Half day leave') ? day.startTime : '--' }}</span>
                      <svg class="dropdown-arrow" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="separator-cell">
                  <span class="time-separator">–</span>
                </div>
                <div class="end-time-cell">
                  <label class="mobile-label">Time to</label>
                  <div class="custom-dropdown time-dropdown-disabled" [class.disabled]="true">
                    <div class="dropdown-selected" [class.disabled]="true">
                      <span class="selected-value">{{ (day.status === 'Working' || day.status === 'Half day leave') ? day.endTime : '--' }}</span>
                      <svg class="dropdown-arrow" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#6b7280" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 8 4 4 4-4"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Divider after each day section (except last) -->
            <div class="section-divider" *ngIf="i < days.length - 1"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-buttons">
        <button class="btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button class="btn-primary" (click)="onSave()" [disabled]="isSubmitting || !hasChanges()">
          <span *ngIf="!isSubmitting">Save</span>
          <span *ngIf="isSubmitting">Saving...</span>
        </button>
      </div>
    </div>
  </div>
</div>

